<template>
    <main-layout>
        <template #header>
            <main-header :title="'시스템 권한 관리'">
            </main-header>
        </template>

        <template #toolbar>
        </template>

        <template #body>
            <div style="flex-grow: 0;">
                <v-tabs
                        v-model="tab"
                        background-color="primary"
                        dark
                >
                    <v-tab
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        {{ item.text }}
                    </v-tab>
                </v-tabs>
            </div>

            <div style="flex-grow: 1;" class="fill-height">
                <v-tabs-items v-model="tab" class="fill-height">
                    <v-tab-item
                            class="fill-height"
                            v-for="item in tabs"
                            :key="item.key"
                    >
                        <component :is="item.component"></component>
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </main-layout>
</template>

<script>
    import MainHeader from "@/components/common/layout/MainHeader";
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainToolbar from "@/components/common/layout/MainToolbar";
    import MainBody from "@/components/common/layout/MainBody";
    import SystemPermissionManageBySystem from "@/views/permission/manage/SystemPermissionManageBySystem";
    import SystemPermissionManageByRentalcompany from "@/views/permission/manage/SystemPermissionManageByRentalcompany";

    const SORT = {
        BY_SYSTEM: "BY_SYSTEM",
        BY_RENTALCOMPANY: "BY_RENTALCOMPANY",
    };

    export default {
        name: "MonitoringAgentDeploy",
        components: {MainBody, MainToolbar, MainLayout, MainHeader},
        data() {
            return {
                tab: SORT.BY_COUNTRY,
                tabs: [
                    {
                        key: SORT.BY_SYSTEM,
                        text: "시스템 권한",
                        component: SystemPermissionManageBySystem,
                    },
                    {
                        key: SORT.BY_RENTALCOMPANY,
                        text: "임대업체 권한",
                        component: SystemPermissionManageByRentalcompany,
                    },
                ]
            };
        },
    }
</script>